<template>
  <v-container fluid>
    <TableItems
        ref="table_attivita"
        model-name-prop="Attivita"
        :loadItemsOnCreated="true"
        :showTopToolbar="true"
        :show-title="false"
        :show-refresh-btn="false"
        :show-new-btn="false"
        @selectedChange="(selected)=> this.selected_attivita = selected"
    >
      <!-- /**/-->

      <template slot="mj_top_toolbar_prepend" slot-scope="data">
        <v-tooltip bottom v-if='data.selected.length > 0'>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                x-small
                color="purple white--text"
                class="ml-2"
                @click="makeMacroWithAttivita"
            >
              <v-icon>mdi-merge</v-icon>
            </v-btn>
          </template>
          <span>Unisci su nuova Macro</span>
        </v-tooltip>
        <v-tooltip bottom v-if='data.selected.length > 0'>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                x-small
                color="blue white--text"
                class="ml-2"
                @click="show_studi_dialog = true"
            >
              <v-icon>mdi-content-duplicate</v-icon>
            </v-btn>
          </template>
          <span>Propaga su studi</span>
        </v-tooltip>

      </template>

    </TableItems>
    <v-dialog v-model="show_studi_dialog" max-width="600px">
      <v-card>
        <v-card-title>Propaga attivita
          <v-spacer></v-spacer>
          <v-btn @click="show_studi_dialog = false" fab x-small>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>

          <div>
            <span class="font-weight-bold">({{ this.selected_attivita.length }}) </span> Attivita selezionate

          </div>
          <ListaStudiSelectable
              @changeSelected="(selected) => this.selected_studi_ids = selected"></ListaStudiSelectable>
          <v-alert type="info" dense small class="mt-2" v-model="show_propagate_message">
            Operazione completata
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="propagateAttivita()" v-show="show_propagate_button">Propaga</v-btn>
          <v-btn color="secondary" @click="show_studi_dialog = false" v-show="show_close_dialog_button">Chiudi</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style>
</style>

<script>
import TableItems from "@/views/TableItems.vue";
import mj_axios from "@/mj_axios";
import ListaStudiSelectable from "./ListaStudiSelectable";


export default {
  components: {ListaStudiSelectable, TableItems},

  computed: {},
  data: () => (
      {
        show_studi_dialog: false,
        show_propagate_message: false,
        show_propagate_button: true,
        show_close_dialog_button: false,
        selected_attivita: [],
        selected_studi_ids: []
      }),

  methods: {

    makeMacroWithAttivita: function () {
      if (
          this.$refs.table_attivita.selected == null ||
          this.$refs.table_attivita.selected.length == 0
      ) {
        this.snack_bar_show = true;
        this.error_text = `Non hai scelto alcuna riga..`;
      } else {
        this.loading_overlay = true;
        this.error_show = false;

        let params = {attivita_ids: this.$refs.table_attivita.selected_ids};
        const axios_promise = mj_axios.post("/api/make_macro_with_attivita", params); //insert

        axios_promise
            .then((response) => {
              this.$refs.table_attivita.selected = [];
              this.$router.push({name: "SchedaAttivita", params: {id: response.data.data.id}});
              // this.$refs.table_attivita.loadItems(false);
            })

            .catch((e) => {
              // const status = e.response ? e.response.status : null;
              let message =
                  e.response && e.response.data ? e.response.data.message : null;

              this.error_show = true;
              this.error_text = `Errore nel Salvataggio dati  ${
                  message ? message : ""
              }`;
            })
            .then(() => {
              this.loading_overlay = false;
            });
      }
    },


    updateFilters: function (data) {


      this.$nextTick(() => {
        // The whole view is rendered, so I can safely access or query
        // the DOM. ¯\_(ツ)_/¯
        this.$refs.table_attivita.updateFilters(data);
        if (this.first_load) {
          this.first_load = false;
          this.$refs.filter_group.collapsePanels();
        }
      })


    },
    propagateAttivita: function () {
      const selected_attivita_ids = this.selected_attivita.map(attivita => attivita.id);
      this.loading++;
      const params = {
        attivita_ids: selected_attivita_ids,
        studio_ids: this.selected_studi_ids
      };
      const axios_promise = mj_axios.post('/api/attivita_propagate_studi', params);
      axios_promise.then(() => {
        this.show_propagate_message = true;
        this.show_propagate_button = false;
        this.show_close_dialog_button = true;

      }).catch(() => {
        this.$store.commit("update_modal_dialog", {
          title: "Attenzione!!",
          text: "Errore di salvataggio, è consigliato, prima di proseguire, risolvere il problema.",
          visible: true,
        });
      }).then(() => {
        this.loading--;
      });
      return axios_promise;
    }
  },

};
</script>


